import React from "react";
import {Navigate} from "react-router-dom";
import {useAuthState} from "../context/AuthContext";
import {RouteHelper} from "./RouteHelper";
import ErrorPage, {ErrorType} from "../component/ErrorPage/ErrorPage";
import {readToken} from "../service/authService/AuthService";
import {RaikoErrorSection} from "@moeindal/base-raiko-panel-components";
import notAccess from "../assets/images/ic-401-error.svg"
import {css} from "@emotion/css";
import {SuperAdmin} from "../accessLevel/SuperAdmin";

export default function PrivateRoute() {

    const state = useAuthState()
    const token = readToken()


    return (
        <>
            {
                token === null
                && !state.loading
                    ?
                    <Navigate to={RouteHelper.SignIn.globalUrl}/>
                    :
                    token !== null && !state.loading && state.role && state.role.length > 0 ?
                        <SuperAdmin/>
                        :
                        state.loading ?
                            <ErrorPage
                                errorType={ErrorType.CONNECTING}
                                title="در حال اتصال به سرور"
                                subTitle="لطفا کمی صبر نمایید..."
                                fullPage={true}/>
                            :
                            <ErrorPage
                                errorType={ErrorType.NOT_ACCESS}
                                title="عدم دسترسی"
                                subTitle="دسترسی شما به این صفحه محدود شده است، لطفا با مدیر سیستم خود تماس حاصل فرمایید!"
                                fullPage={true}/>
            }
        </>
    )

}